// extracted by mini-css-extract-plugin
module.exports = {"modal__wrap":"AlertModal_modal__wrap__2B_fg","modal":"AlertModal_modal__2zKzy","rotating":"AlertModal_rotating__2iaEl"};